/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { CatalogListCatalogsResponse } from "./CatalogListCatalogsResponse";

export type CatalogListCatalogsResponseApiRespoonse = {
  data?: CatalogListCatalogsResponse;
  status?: CatalogListCatalogsResponseApiRespoonse.status;
  message?: string;
  errors?: Record<string, Array<string>>;
};

export namespace CatalogListCatalogsResponseApiRespoonse {
  export enum status {
    SUCCESS = "success",
    ERROR = "error",
  }
}
